export { default } from './CategoryTable';
